import { SVGAttributes } from 'react';

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            {...props}
            viewBox="0 0 11.875 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m1.5625 0.3125v14.288c0.40714 0.20524 0.95651 0.37579 1.648 0.51025 0.69144 0.13447 1.3491 0.20142 1.9739 0.20142 1.5584 0 2.8028-0.46584 3.7329-1.3965 0.93011-0.93065 1.3953-2.1813 1.3953-3.7524 0-1.465-0.38903-2.6644-1.1682-3.5986-0.77918-0.93419-1.783-1.4014-3.0115-1.4014-0.94064 0-1.8255 0.30445-2.6538 0.91309v-5.7642zm4.0955 6.6565c0.80726 0 1.4622 0.30445 1.9641 0.91309 0.50191 0.60864 0.75317 1.3974 0.75317 2.3669 0 0.95542-0.26866 1.7376-0.80566 2.3462-0.53701 0.60864-1.2307 0.91308-2.0801 0.91308-0.68793 0-1.3577-0.09969-2.0105-0.29785v-5.2869c0.73707-0.63694 1.4629-0.95459 2.179-0.95459zm-5.3455 10.844v1.875h11.25v-1.875z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}
